/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/DesignSystem/TimegridOverrideTemplate/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let templateOverrideSubmitData = fromData.useDataSubmit({ viewPath,
context: 'template_override',
})
let templateOverrideIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'template_override',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="template_override"
 onClick={templateOverrideSubmitData}
 disabled={templateOverrideIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}